import { lazy } from "react";
import { Navigate, Outlet } from "react-router-dom";
// auth
import { AuthGuard } from "src/auth/guard";
// routes
import { paths } from "src/routes/paths";
// layouts
import ErrorBoundary from "src/layouts/dashboard/error-boundary";
import DashboardLayout from "src/layouts/dashboard/layout";
// import TransactionList from "src/pages/dashboard/transaction";

// ----------------------------------------------------------------------

// // API
// const ApiKeysPage = lazy(() => import("src/pages/dashboard/api-set-up/api-keys"));
// // SHIPMENTS
const ShipmentPage = lazy(() => import("src/pages/dashboard/shipments/shipment"));
// // SETTINGS
const SettingsAccountPage = lazy(() => import("src/pages/dashboard/settings/account"));
const SettingsAddressBookPage = lazy(() => import("src/pages/dashboard/settings/address-book"));
const SettingsCarriersPage = lazy(() => import("src/pages/dashboard/settings/carrier"));

const TransactionListPage = lazy(() => import("src/pages/dashboard/transaction"));
const ShipmentListPage = lazy(() => import("src/pages/dashboard/shipments/list"));


// ----------------------------------------------------------------------

export const dashboardRoutes = [
    {
        path: "/",
        element: (
            <AuthGuard>
                <ErrorBoundary>
                    <DashboardLayout>
                        <Outlet />
                    </DashboardLayout>
                </ErrorBoundary>
            </AuthGuard>
        ),
        children: [
            // { path: "", element: <Navigate to={ paths.dashboard.api.key.root } replace /> },
            // //
            // {
            //     path: "api",
            //     children: [
            //         { path: "key", element: <ApiKeysPage />, index: true }
            //     ]
            // },
            {
                path: "shipments",
                children: [
                    { element: <ShipmentPage />, path: 'create' },
                    { element: <ShipmentListPage />, path: "list" },
                    //
                    // { path: "schedule_pickup_usps", element: <PickupScheduleUSPSPage /> },
                    // { path: "schedule_pickup_ups", element: <PickupScheduleUPSPage /> },
                    // { path: "schedule_scan_form", element: <ScanFormSchedulePage /> },
                    // { path: "quick_rate", element: <QuickRate /> },
                    // //
                    // { path: "create", element: <ShipmentsCreate /> },
                    // { path: "create/:id", element: <ShipmentsCreate /> },
                    // { path: ":id", element: <ShipmentsDetail /> }
                ]
            },
            {
                path: "transactions",
                children: [
                    { element: <TransactionListPage />, index: true },
                ]
            },
            {
                path: "settings",
                children: [
                    { path: "profile", element: <SettingsAccountPage /> },
                    { path: "address_book", element: <SettingsAddressBookPage /> },
                    { path: "carriers", element: <SettingsCarriersPage />, index: true }
                ]
            }
        ]
    }
];
